import React from 'react';
import './Footer.scss';

const Footer = () => {
  return (
    <div className="footer">Powered by Dishant</div>
  ); 
}

export default Footer;
